// extracted by mini-css-extract-plugin
export var option = "_kt-0";
export var optionCard = "_kt-f";
export var optionContent = "_kt-g";
export var optionIcon = "_kt-i";
export var optionIconBox = "_kt-h";
export var optionLabel = "_kt-j";
export var optionPill = "_kt-m";
export var optionPillBadge = "_kt-p";
export var optionPillIcon = "_kt-n";
export var optionPillLabel = "_kt-o";
export var optionRadio = "_kt-k";
export var optionRadioInner = "_kt-l";
export var optionReveal = "_kt-2";
export var optionRevealDelay0 = "_kt-3";
export var optionRevealDelay1 = "_kt-4";
export var optionRevealDelay10 = "_kt-d";
export var optionRevealDelay11 = "_kt-e";
export var optionRevealDelay2 = "_kt-5";
export var optionRevealDelay3 = "_kt-6";
export var optionRevealDelay4 = "_kt-7";
export var optionRevealDelay5 = "_kt-8";
export var optionRevealDelay6 = "_kt-9";
export var optionRevealDelay7 = "_kt-a";
export var optionRevealDelay8 = "_kt-b";
export var optionRevealDelay9 = "_kt-c";
export var optionSelected = "_kt-1";